import createIcon from '../../createIcon';

/**
 * @component @name PrivateConnectivity
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTMgMTFDMTguNDQgNy42MSAxNS41MyA1IDEyIDVDOC40NyA1IDUuNTYgNy42MSA1LjA3IDExSDJWMTNINS4wN0M1LjU2IDE2LjM5IDguNDcgMTkgMTIgMTlDMTUuNTMgMTkgMTguNDQgMTYuMzkgMTguOTMgMTNIMjJWMTFIMTguOTNaTTE1IDE0LjVDMTUgMTUuMDUgMTQuNTUgMTUuNSAxNCAxNS41SDEwQzkuNDUgMTUuNSA5IDE1LjA1IDkgMTQuNVYxMS41QzkgMTAuOTUgOS40NSAxMC41IDEwIDEwLjVWOS41QzEwIDguMjkgMTEuMDggNy4zMiAxMi4zNCA3LjUzQzEzLjMyIDcuNjkgMTQgOC42MSAxNCA5LjYxVjEwLjVDMTQuNTUgMTAuNSAxNSAxMC45NSAxNSAxMS41VjE0LjVaTTEyLjc1IDEzQzEyLjc1IDEzLjQxIDEyLjQxIDEzLjc1IDEyIDEzLjc1QzExLjU5IDEzLjc1IDExLjI1IDEzLjQxIDExLjI1IDEzQzExLjI1IDEyLjU5IDExLjU5IDEyLjI1IDEyIDEyLjI1QzEyLjQxIDEyLjI1IDEyLjc1IDEyLjU5IDEyLjc1IDEzWk0xMyA5LjVWMTAuNUgxMVY5LjVDMTEgOC45NSAxMS40NSA4LjUgMTIgOC41QzEyLjU1IDguNSAxMyA4Ljk1IDEzIDkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PrivateConnectivity = createIcon('PrivateConnectivity', [
  [
    'path',
    {
      d: 'M18.93 11C18.44 7.61 15.53 5 12 5C8.47 5 5.56 7.61 5.07 11H2V13H5.07C5.56 16.39 8.47 19 12 19C15.53 19 18.44 16.39 18.93 13H22V11H18.93ZM15 14.5C15 15.05 14.55 15.5 14 15.5H10C9.45 15.5 9 15.05 9 14.5V11.5C9 10.95 9.45 10.5 10 10.5V9.5C10 8.29 11.08 7.32 12.34 7.53C13.32 7.69 14 8.61 14 9.61V10.5C14.55 10.5 15 10.95 15 11.5V14.5ZM12.75 13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13C11.25 12.59 11.59 12.25 12 12.25C12.41 12.25 12.75 12.59 12.75 13ZM13 9.5V10.5H11V9.5C11 8.95 11.45 8.5 12 8.5C12.55 8.5 13 8.95 13 9.5Z',
      key: '1f3eyb',
    },
  ],
]);

export default PrivateConnectivity;
